export var DEFAULT_STYLE = {
    left: "0vw",
    top: "0vh",
    backgroundColor: "#A0A0A0aa",
    borderRadius: "5px",
};
//# sourceMappingURL=constants.js.map